import { ArrowRight, Info } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface GetYourTicketsButtonProps {
  orderId: string;
  disabled: boolean;
  orderHasMultipleTickets: boolean;
  hasAddonsOrTopUps: boolean;
  displayTickets: boolean;
}

const GetYourTicketsButton: React.FC<GetYourTicketsButtonProps> = ({
  orderId,
  disabled,
  orderHasMultipleTickets,
  hasAddonsOrTopUps,
  displayTickets,
}) => {
  const { t } = useTranslation();

  const buttonText = displayTickets
    ? t(
        `orderConfirmationPage.${
          orderHasMultipleTickets ? 'downloadTickets' : 'downloadTicket'
        }`,
      )
    : t('common.continue');

  return (
    <div className="py-[16px] border-t border-neutral-40 mx-[-16px] px-[16px] sm:mx-[-24px] sm:px-[24px] flex justify-end">
      {disabled ? (
        <>
          <Popover>
            <PopoverTrigger asChild>
              <Button variant="ghost" size="icon" type="button">
                <Info size={16} />
              </Button>
            </PopoverTrigger>
            <PopoverContent side="top" className="text-center p3-medium p-2">
              {displayTickets
                ? t('orderConfirmationPage.downloadTicketsTooltip')
                : t('orderConfirmationPage.yourTicketsTooltip')}
            </PopoverContent>
          </Popover>
          <Button disabled type="submit" form="contact-form">
            {buttonText}
            <ArrowRight />
          </Button>
        </>
      ) : (
        <Link
          to={`/order/confirmation?uuid=${orderId}`}
          state={{ eventHasRegistrationForms: true, hasAddonsOrTopUps }}
          className="block w-fit"
        >
          <Button disabled={disabled} type="submit" form="contact-form">
            {buttonText}
            <ArrowRight />
          </Button>
        </Link>
      )}
    </div>
  );
};

export default GetYourTicketsButton;
